import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import GreetingOccasionCategoriesPage from "./greeting-occasion-categories-page";
import GreetingOccasionCategoryCreatePage from "./greeting-occasion-category-create-page";
import GreetingOccasionCategoryEditPage from "./greeting-occasion-category-edit-page";
 

export default (
  <Route path="greeting-occasion-categories">
    <Route
      index
      element={
        <Protected
          path="/admin/greeting-occasion-categories"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingOccasionCategoriesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/greeting-occasion-categories/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingOccasionCategoryCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/greeting-occasion-categories/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingOccasionCategoryEditPage />
        </Protected>
      }
    />  
  </Route>
);




